// src/pages/produtos/subGrupos/SubGrupoCad.js
// components/SubGrupoCad.js
import React, { useState, useEffect } from 'react';

import SubGrupoSearch from './SubGrupoSearch';
import { SubGrupo } from '../../../models/produtos/SubGrupo';
import { useSubGrupo } from '../../../contexts/produtos/SubGrupoContext';
import Input from '../../../components/input/Input';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import { Grupo } from '../../../models/produtos/Grupo';
import { useGrupo } from '../../../contexts/produtos/GrupoContext';
import GrupoSearch from '../grupos/GrupoSearch';
import GrupoCad from '../grupos/GrupoCad';
import ModalActions, { ModalActionButton } from '../../../components/modalForm/ModalActions';

const SubGrupoCad = ({ show, onHide }) => {
    const { subGrupos, addSubGrupo, updateSubGrupo, deleteSubGrupo } = useSubGrupo();
    const [subGrupo, setSubGrupo] = useState(new SubGrupo());
    const { grupos } = useGrupo();
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [showSearchGrupo, setShowSearchGrupo] = useState(false);
    const [showCadGrupo, setShowCadGrupo] = useState(false);
    const { showMessage } = useMessage();
    const { showYesNo } = useYesNo();
    const [novoReg, setNovoReg] = useState(false);

    useEffect(() => {
        if (show) {
            handleNovo();
        }
    }, [show]);

    const handleNovo = () => {
        setSubGrupo(new SubGrupo());
        setNovoReg(true);
    };

    const handleEditar = (id) => {
        if (id === 0) {
            showMessage("Selecione um SubGrupo para editar!");
            return;
        }
        setNovoReg(false);
    };

    const handleDelete = async () => {
        if (!subGrupo?.id) {
            showMessage("Selecione um SubGrupo para excluir!");
        } else {
            const resposta = await showYesNo("Deseja excluir o subgrupo selecionado?");
            if (resposta) {
                await deleteSubGrupo(subGrupo.id);
                handleNovo();
            }
        }
    };

    const handleSave = async () => {
        try {
            if (!subGrupo.descricao) {
                showMessage("Informe uma descrição para o subgrupo!");
                return;
            }

            // Criar payload sem o objeto grupo
            const payload = {
                ...subGrupo,
                grupoId: subGrupo.grupo.id,
            };

            // Remover propriedades desnecessárias
            delete payload.grupo;

            if (!subGrupo.id) {
                await addSubGrupo(subGrupo);
            } else {
                await updateSubGrupo(subGrupo);
            }
            handleNovo();
        } catch (error) {
            console.error("Erro ao gravar dados: ", error);
        }
    };

    const handleExit = () => {
        const subGrupoSel = subGrupos.find(sg => sg.id.toString() === subGrupo?.id?.toString());

        if (subGrupoSel) {
            const grupoSelecionado = grupos.find(g => g.id.toString() === subGrupoSel.grupoId.toString());
            subGrupoSel.grupo=grupoSelecionado;
            setSubGrupo(subGrupoSel);
            //handleExitGrupo(subGrupoSel?.grupoId);
            handleEditar(subGrupo?.id);
        } else {
            setSubGrupo(new SubGrupo());
        }
    };

    const handleExitGrupo = (grupoId) => {
        const grupoSelecionado = grupos.find(g => g.id.toString() === grupoId.toString());
        if (grupoSelecionado) {
            setSubGrupo({ ...subGrupo, grupo: grupoSelecionado });
        } else {
            setSubGrupo({ ...subGrupo, grupo: new Grupo() });
        }
    };

    const handleSelectGrupo = (grupo) => {
        setSubGrupo({ ...subGrupo, grupo, grupoId: grupo.id });
        setShowSearchGrupo(false);
    };

    // const handleSelectGrupo = (grupo) => {
    //     if (produto.Grupo?.id !== grupo.id) {
    //         setProduto({ ...produto, grupo, subGrupo: new SubGrupo(), subGrupoId: null });
    //     } else {
    //         setProduto({ ...produto, grupo });
    //     }        
    //     setShowSearchGrupo(false);
    // };

    const handleSelectSubGrupo = (subGrupoSel) => {

        setShowSearchModal(false);
        if (subGrupoSel) {
            const grupoSelecionado = grupos.find(g => g.id.toString() === subGrupoSel.grupoId.toString());
            subGrupoSel.grupo=grupoSelecionado;
            setSubGrupo(subGrupoSel);
            handleEditar(subGrupoSel.id);
        } else {
            setSubGrupo(new SubGrupo());
        }
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} variant="cadastro" onHide={onHide}>
            <ModalHeader title={novoReg ? 'Novo SubGrupo' : 'Alterar SubGrupo'} onHide={onHide} />
            <ModalBody>
                <form>
                    <div className="input-group mb-3">
                        <Input
                            label="Código"
                            value={subGrupo.id || ''}
                            onChange={(e) => setSubGrupo({ ...subGrupo, id: e.target.value })}
                            onBlur={handleExit}
                            disabled={!novoReg}
                            btnBuscar={() => setShowSearchModal(true)}
                        />
                        <Input
                            label="Descrição"
                            value={subGrupo.descricao || ''}
                            onChange={(e) => setSubGrupo({ ...subGrupo, descricao: e.target.value })}
                            size={300}
                            autoFocus={true}
                        />
                    </div>
                    <div className="input-group mb-3">                                
                        <Input
                            label="Grupo"
                            value={subGrupo.grupoId || ''}                                                
                            onChange={(e) => setSubGrupo({ ...subGrupo, grupoId: e.target.value })}
                            onBlur={(e) => handleExitGrupo(e.target.value)}                            
                            btnBuscar={() => setShowSearchGrupo(true)}
                            btnAdd={() => setShowCadGrupo(true)}
                            size={80}
                        />   
                        <Input
                            value={subGrupo.grupo?.descricao || ''}                                        
                            size={300}
                            disabled                                  
                        /> 
                    </div>
                </form>
            </ModalBody>
            <ModalFooter>
                <ModalActions >
                    <ModalActionButton type='button' className="btn btn-primary" onClick={handleSave} action="save">
                        Salvar
                    </ModalActionButton>
                    <ModalActionButton type='button' className="btn btn-danger" onClick={handleDelete} disabled={novoReg} action="delete">
                        Excluir
                    </ModalActionButton>
                    <ModalActionButton type='button' className="btn btn-secondary" onClick={handleNovo} disabled={novoReg} action="new">
                        Novo
                    </ModalActionButton>
                </ModalActions>
            </ModalFooter>

            <SubGrupoSearch
                show={showSearchModal}
                onHide={() => setShowSearchModal(false)}
                onSelectSubGrupo={handleSelectSubGrupo}
            />

            <GrupoSearch
                show={showSearchGrupo}
                onHide={() => setShowSearchGrupo(false)}
                onSelectGrupo={handleSelectGrupo}                
            />
            <GrupoCad
                show={showCadGrupo}
                onHide={() => setShowCadGrupo(false)}
            />
        </ModalContainer>
    );
};

export default SubGrupoCad;